import {
  animate,
  state,
  style,
  transition,
  trigger,
  AnimationTriggerMetadata,
} from '@angular/animations';

/**
 * Mirrors Angular Material's `mat-select` `transformPanel` (v16):
 * - `void → showing`: 120ms cubic-bezier(0, 0, 0.2, 1), scale-Y 0.8 → 1 + opacity 0 → 1
 * - `* → void`:        100ms linear, opacity → 0
 *
 * The transform-origin is set on the panel host based on whether the panel
 * opens above or below the trigger (`app-select__panel--above` flips it).
 */
export const transformPanel: AnimationTriggerMetadata = trigger(
  'transformPanel',
  [
    state('void', style({ opacity: 0, transform: 'scale(1, 0.8)' })),
    transition(
      'void => showing',
      animate(
        '120ms cubic-bezier(0, 0, 0.2, 1)',
        style({ opacity: 1, transform: 'scale(1, 1)' })
      )
    ),
    transition('* => void', animate('100ms linear', style({ opacity: 0 }))),
  ]
);
